// extracted by mini-css-extract-plugin
export var grid = "_1a-0";
export var span1 = "_1a-2";
export var span10 = "_1a-b";
export var span10L = "_1a-z";
export var span10M = "_1a-n";
export var span10Xl = "_1a-1b";
export var span11 = "_1a-c";
export var span11L = "_1a-10";
export var span11M = "_1a-o";
export var span11Xl = "_1a-1c";
export var span12 = "_1a-d";
export var span12L = "_1a-11";
export var span12M = "_1a-p";
export var span12Xl = "_1a-1d";
export var span1L = "_1a-q";
export var span1M = "_1a-e";
export var span1Xl = "_1a-12";
export var span2 = "_1a-3";
export var span2L = "_1a-r";
export var span2M = "_1a-f";
export var span2Xl = "_1a-13";
export var span3 = "_1a-4";
export var span3L = "_1a-s";
export var span3M = "_1a-g";
export var span3Xl = "_1a-14";
export var span4 = "_1a-5";
export var span4L = "_1a-t";
export var span4M = "_1a-h";
export var span4Xl = "_1a-15";
export var span5 = "_1a-6";
export var span5L = "_1a-u";
export var span5M = "_1a-i";
export var span5Xl = "_1a-16";
export var span6 = "_1a-7";
export var span6L = "_1a-v";
export var span6M = "_1a-j";
export var span6Xl = "_1a-17";
export var span7 = "_1a-8";
export var span7L = "_1a-w";
export var span7M = "_1a-k";
export var span7Xl = "_1a-18";
export var span8 = "_1a-9";
export var span8L = "_1a-x";
export var span8M = "_1a-l";
export var span8Xl = "_1a-19";
export var span9 = "_1a-a";
export var span9L = "_1a-y";
export var span9M = "_1a-m";
export var span9Xl = "_1a-1a";
export var stretch = "_1a-1";